exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Nope__nope___aQVOa {\n  font-size: 18px;\n  margin: 16px 0;\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"nope": "Nope__nope___aQVOa"
};